module.exports = __webpack_public_path__ + "static/media/Tammie.d3c9cb1f.jpeg";